export enum InvoiceProcessingStatus {
    // Étapes intermédiaires (in_progress)
    TechnicalValidationInProgress = 'technical_validation_in_progress',
    RelevanceCheckInProgress = 'relevance_check_in_progress',
    OcrInProgress = 'ocr_in_progress',
    PartnerIdentificationInProgress = 'partner_identification_in_progress',
    QualificationInProgress = 'qualification_in_progress',
    MappingInProgress = 'mapping_in_progress',
    AllocationInProgress = 'allocation_in_progress',

    // Échecs retryables (retry-ocr / abandon-ocr)
    RelevanceCheckFailed = 'relevance_check_failed',
    OcrFailed = 'ocr_failed',
    PartnerIdentificationFailed = 'partner_identification_failed',
    QualificationFailed = 'qualification_failed',
    MappingFailed = 'mapping_failed',

    // Pseudo-terminaux replace-file
    ValidationFailed = 'validation_failed',
    NotAnInvoice = 'not_an_invoice',

    // Terminaux finaux
    Ready = 'ready',
    ConsistencyWarning = 'consistency_warning',
    Abandoned = 'abandoned',
    NotApplicable = 'not_applicable',
}

export const IN_PROGRESS_STATUSES: InvoiceProcessingStatus[] = [
    InvoiceProcessingStatus.TechnicalValidationInProgress,
    InvoiceProcessingStatus.RelevanceCheckInProgress,
    InvoiceProcessingStatus.OcrInProgress,
    InvoiceProcessingStatus.PartnerIdentificationInProgress,
    InvoiceProcessingStatus.QualificationInProgress,
    InvoiceProcessingStatus.MappingInProgress,
    InvoiceProcessingStatus.AllocationInProgress,
];

export const FAILED_STATUSES: InvoiceProcessingStatus[] = [
    InvoiceProcessingStatus.RelevanceCheckFailed,
    InvoiceProcessingStatus.OcrFailed,
    InvoiceProcessingStatus.PartnerIdentificationFailed,
    InvoiceProcessingStatus.QualificationFailed,
    InvoiceProcessingStatus.MappingFailed,
];

export const REPLACE_FILE_STATUSES: InvoiceProcessingStatus[] = [
    InvoiceProcessingStatus.ValidationFailed,
    InvoiceProcessingStatus.NotAnInvoice,
];

export const TERMINAL_ACCEPTABLE_STATUSES: InvoiceProcessingStatus[] = [
    InvoiceProcessingStatus.Ready,
    InvoiceProcessingStatus.Abandoned,
    InvoiceProcessingStatus.NotApplicable,
];

/**
 * Config visuelle d'un statut pipeline pour rendu badge `<p-tag>`.
 * Aligné sur le pattern BankStatement (cf. `bank-statements-table.component.ts:getStatusConfig`).
 */
export interface InvoiceProcessingStatusConfig {
    label: string;
    severity: 'success' | 'secondary' | 'info' | 'warn' | 'danger' | 'contrast' | undefined;
    spinning?: boolean;
    aiTag?: any;
}

/** Option de filtre multi-select sur le statut pipeline (1 statut = 1 option). */
export interface InvoiceProcessingStatusOption extends InvoiceProcessingStatusConfig {
    value: InvoiceProcessingStatus;
}
